import { useCallback } from 'react';

import { useAuthentication } from '@givebacks/api';
import { useUrlSearchParams } from 'core/Hooks';
import { useFeatureValue } from 'core/Packages';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, ImageMantine } from 'ui';

import { useNavigateToAuth } from '../../../hooks/useNavigateToAuth/useNavigateToAuth';
import { PostCheckoutRedirectPageTemplate } from '../PostCheckoutRedirectPageTemplate/PostCheckoutRedirectPageTemplate';
import { POST_CHECKOUT_IMAGE_URLS } from '../postCheckoutImageUrls';

const ReceiptRedirectPage = () => {
  const { handleNavigateToAuth } = useNavigateToAuth();
  const { isAuthenticated } = useAuthentication();
  const navigate = useNavigate();
  const { email, firstName, lastName } = useUrlSearchParams(['email', 'firstName', 'lastName']);

  useFeatureValue<'A'>('ic_non-membership_without_stg', 'A');

  const PURCHASES_ROUTE = '/account/purchases';

  const onPrimaryCtaClick = useCallback(() => {
    if (isAuthenticated) {
      navigate(PURCHASES_ROUTE);
      return;
    }

    handleNavigateToAuth({
      page: 'sign-up',
      redirect: PURCHASES_ROUTE,
      additionalParams: {
        firstName,
        lastName,
        email,
      },
    });
  }, [
    isAuthenticated,
    handleNavigateToAuth,
    email,
    firstName,
    lastName,
    navigate,
    PURCHASES_ROUTE,
  ]);

  return (
    <PostCheckoutRedirectPageTemplate
      title="View all your purchases in one place with the Givebacks app"
      leftSection={
        <PostCheckoutRedirectPageTemplate.AppBenefits>
          <PostCheckoutRedirectPageTemplate.AppBenefit>
            View all your receipts and payment history for all your organizations
          </PostCheckoutRedirectPageTemplate.AppBenefit>
          <PostCheckoutRedirectPageTemplate.AppBenefit>
            Manage donations and purchases for all your organizations
          </PostCheckoutRedirectPageTemplate.AppBenefit>
          <PostCheckoutRedirectPageTemplate.AppBenefit>
            Access fundraisers and online stores for all your organizations
          </PostCheckoutRedirectPageTemplate.AppBenefit>
        </PostCheckoutRedirectPageTemplate.AppBenefits>
      }
      rightSection={<ImageMantine src={POST_CHECKOUT_IMAGE_URLS.receipt} />}
      cta={<ButtonMantine onClick={onPrimaryCtaClick}>View All Purchases</ButtonMantine>}
    />
  );
};

export { ReceiptRedirectPage };
